import { Input, InputProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  .ant-input-affix-wrapper {
    border-radius: 16px !important;
  }
  .ant-input {
    border-radius: 16px !important;
  }
  .ant-form-item-explain-error {
    color: var(--error) !important;
  }

  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
    border-color: var(--error) !important;
  }
`;

export type InputPropsInterface = InputProps;

const component = (props: InputPropsInterface) => {
  return (
    <InputWrapper>
      <Input {...props} />
    </InputWrapper>
  );
};

export default component;
